import React from "react";
import { Link } from "react-router-dom";
import { Users, Shield, ClipboardList, Boxes, GraduationCap, KeyRound, Rocket, Truck, Store, Building2, Activity, BarChart3, Grid3X3, Megaphone, ShoppingBag, CreditCard, Bot, Mail } from "lucide-react";
import EcosystemReadinessWidget from "../../components/admin/EcosystemReadinessWidget";
import AdminPartnerApplicationsCard from "../../components/admin/AdminPartnerApplicationsCard";
import AdminNotificationsSummary from "../../components/admin/AdminNotificationsSummary";

const CARDS = [
  { to: "/admin/command-center", label: "Command Center", icon: Activity, blurb: "Cross-module KPIs, ecosystem map, alerts. Phase 9." },
  { to: "/admin/square-operations", label: "Square Operations", icon: CreditCard, blurb: "Live revenue · catalog sync · inventory · data cleanup. Master admin only." },
  { to: "/admin/ai-workspace", label: "AI Workspace", icon: Bot, blurb: "Claude operator console · approval-gated suggestions · audit log." },
  { to: "/admin/support-email", label: "Support Email", icon: Mail, blurb: "Microsoft 365 inbox · Claude drafts · send / reply / audit." },
  { to: "/admin/roles-catalog", label: "Roles Catalog", icon: Shield, blurb: "Source of truth for every role. Verify role separation before deploy." },
  { to: "/admin/readiness-matrix", label: "Readiness matrix", icon: Grid3X3, blurb: "Subsystem × dimension matrix (Routes · APIs · Data · Permissions · UI)." },
  { to: "/reports",          label: "Reports",      icon: BarChart3,     blurb: "Cross-module rollups, role-scoped views, CSV exports. Phase 11." },
  { to: "/admin/users",      label: "Users",        icon: Users,         blurb: "View users, assign roles, manage status." },
  { to: "/admin/roles",      label: "Roles & permissions", icon: Shield, blurb: "Inspect the role catalog and per-role permissions." },
  { to: "/admin/audit-logs", label: "Audit logs",   icon: ClipboardList, blurb: "Every auth & role mutation, time-stamped." },
  { to: "/admin/inventory", label: "Lifted Inventory", icon: ShoppingBag, blurb: "Native Shopify-style product editor — Lifted is the System of Record." },
  { to: "/admin/shopify-migration", label: "Imported (Legacy reference)", icon: ShoppingBag, blurb: "Read-only audit of the original Shopify import. No live sync required." },
  { to: "/admin/training",   label: "Training",     icon: GraduationCap, blurb: "Modules, tracks, certifications, seminars, announcements." },
  { to: "/admin/affiliate",  label: "Affiliate",    icon: Rocket,        blurb: "Profiles, commission ledger, payouts, tier thresholds." },
  { to: "/admin/delivery",   label: "Delivery",     icon: Truck,         blurb: "Dispatch, drivers, zones, fee config, earnings." },
  { to: "/admin/partners",   label: "Partners",     icon: Store,         blurb: "Compliance, fulfillment + metrics — flows into dispatch." },
  { to: "/admin/franchises", label: "Franchises",   icon: Building2,     blurb: "Territories + partner roster. Reuses dispatch board." },
  { to: "/landing-pad",      label: "Landing Pad",  icon: Megaphone,     blurb: "Internal team comms — broadcast, role-targeted, support requests." },
  { to: "/admin/access-codes", label: "Access codes", icon: KeyRound,    blurb: "Invite codes — system-default protected." },
];

export default function AdminHome() {
  return (
    <div className="space-y-8">
      <header className="fade-up">
        <div className="eyebrow">Master command</div>
        <h1 className="headline-xl">Admin center</h1>
        <p className="text-lifted-dim mt-2 max-w-2xl">
          The ecosystem control plane. Only master admin may mutate roles.
        </p>
      </header>

      {/* Iter65 Addition 2 + 4 — live notifications + activity (top of page for visibility) */}
      <AdminNotificationsSummary />

      <EcosystemReadinessWidget />

      {/* Iter60 Task 2 — Partner application notifications, front-and-center */}
      <AdminPartnerApplicationsCard />

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {CARDS.map((c, i) => {
          const body = (
            <div className={`glass-panel p-6 fade-up delay-${(i % 5) + 1} ${c.disabled ? "opacity-50" : "hover:-translate-y-1 hover:border-lifted-green/30 transition-transform"}`}>
              <div className="flex items-center gap-4">
                <div className="h-11 w-11 rounded-xl border border-lifted-green/30 bg-lifted-green/10 text-lifted-green flex items-center justify-center">
                  <c.icon className="h-5 w-5" />
                </div>
                <div>
                  <div className="font-anton text-2xl uppercase">{c.label}</div>
                  <div className="text-sm text-lifted-dim">{c.blurb}</div>
                </div>
              </div>
            </div>
          );
          return c.disabled ? <div key={c.label}>{body}</div> : <Link key={c.label} to={c.to}>{body}</Link>;
        })}
      </div>
    </div>
  );
}
